import { MODAL_WIDTH } from '../../../constants/ForestConstant';
import React from 'react';
import { useCurrentMember } from '../../../redux/selector';
import { ModalProps } from 'antd/lib/modal/Modal';
import CreateFlow from './CreateFlow';
import TrackingFullScreenModal from '../../app-views/components/TrackingFullScreenModal';
import CenterLayout from '../components/CenterLayout';

type OnboardingModalProps = Omit<ModalProps, 'onCancel'> & {
  onClose?: () => void;
};

const OnboardingModal: React.FC<OnboardingModalProps> = ({ onClose, ...rest }) => {
  const currentMember = useCurrentMember();

  const closeInternal = () => {
    onClose && onClose();
  };
  return (
    <TrackingFullScreenModal
      name="UI/VENDOR_LINK/ONBOARDING/MODAL"
      properties={() => ({ currentMemberId: currentMember?.memberId })}
      width={MODAL_WIDTH}
      {...rest}
      onCancel={closeInternal}
    >
      <CenterLayout>
        <CreateFlow onComplete={closeInternal} onCancel={closeInternal} />
      </CenterLayout>
    </TrackingFullScreenModal>
  );
};

export default OnboardingModal;
